export const errorsMessages = {
  passwordTooShort: 'Password is too short',
  passwordIncorrect: 'Incorrect password',
  passwordsNotMatch: 'Passwords do not match',
  usernameEmpty: 'Please, enter username',
  emailEmpty: 'Please, enter valid e-mail',
  usernameIsTooLong: 'Username should be shorter than 12 symbols',
  emailIsTooLong: 'Email is too long'
}